import { render } from "./ChatDisplay.vue?vue&type=template&id=45f9d6d3&scoped=true&ts=true"
import script from "./ChatDisplay.vue?vue&type=script&lang=ts"
export * from "./ChatDisplay.vue?vue&type=script&lang=ts"

import "./ChatDisplay.vue?vue&type=style&index=0&id=45f9d6d3&lang=css"
import "./ChatDisplay.vue?vue&type=style&index=1&id=45f9d6d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9d6d3"]])

export default __exports__